import { formatMeasurement } from "./formatMeasurement";

export const formatDisplayValue = (value, format) => {
  if (value === null || value === undefined || value === "") return "";
  if (!format || (format !== "weight" && format !== "dimension")) return value;

  if (typeof value === "number") {
    return formatMeasurement(value, format);
  }

  const rawValue = String(value).trim();

  if (format === "dimension" && /x/i.test(rawValue)) {
    const matchDimension = rawValue.match(/^(.+?)(?:\s+([a-zA-Z0-9%]+))?$/);
    if (!matchDimension) return value;

    const dimensionsPart = matchDimension[1];
    const unitPart = matchDimension[2] ? matchDimension[2].trim() : "";
    const formattedDimensions = dimensionsPart
      .split(/x/i)
      .map((part) => {
        const formattedPart = formatMeasurement(part.trim(), format);
        return formattedPart === "-" ? part.trim() : formattedPart;
      })
      .join("x");

    return unitPart ? `${formattedDimensions} ${unitPart}` : formattedDimensions;
  }

  const match = rawValue.match(
    /^(-?(?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d+)?)(?:\s*(.*))?$/
  );
  if (!match) return value;

  const numericPart = match[1].replace(/,/g, "");
  const unitPart = match[2] ? match[2].trim() : "";
  const formattedValue = formatMeasurement(numericPart, format);
  if (formattedValue === "-") return value;

  return unitPart ? `${formattedValue} ${unitPart}` : formattedValue;
};
